module.exports = __webpack_public_path__ + "img/avatar1.7efe04a8.png";